import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './plugins/axios-plugin';
import {i18n} from '@/plugins/i18n-plugin';
import components from '@/plugins/component-plugin';
import loading from '@/plugins/loading';
import VueToastr2 from 'vue-toastr-2';
import 'vue-toastr-2/dist/vue-toastr-2.min.css';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';

import Highcharts from 'highcharts';
import highchartsMore from 'highcharts/highcharts-more';
import hightChartsExport from 'highcharts/modules/exporting';
import sankey from 'highcharts/modules/sankey';
import organization from 'highcharts/modules/organization';
import funnelChart from 'highcharts/modules/funnel';
import variablePieChart from 'highcharts/modules/variable-pie';
import mapChart from 'highcharts/modules/map';
import accessibilityChart from 'highcharts/modules/accessibility';
import chartData from 'highcharts/modules/data';
import addWorldMap from '@/plugins/world';

import HighChartsVue from 'highcharts-vue';

import VueCookies from 'vue-cookies';


window.toastr = require('toastr')

highchartsMore(Highcharts)
sankey(Highcharts)
organization(Highcharts)
funnelChart(Highcharts)
variablePieChart(Highcharts)
mapChart(Highcharts)
accessibilityChart(Highcharts)
chartData(Highcharts)
addWorldMap(Highcharts)
hightChartsExport(Highcharts)


Vue.use(axios)
Vue.use(VueToastr2)
Vue.use(components)
Vue.use(loading)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(HighChartsVue)
Vue.use(VueCookies)


Vue.config.productionTip = false

new Vue({
    render: h => h(App),
    router,
    store,
    i18n
}).$mount('#app')
